import { Color24, Colors24 } from '@grammarly/badger-ui'

interface WebinarProps {
  color?: Color24
}

export const OpenBookIcon = (props: WebinarProps) => {
  const { color = 'green60' } = props
  const strokeColor = Colors24[color]
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10 5.21V16.0433M10 5.21C9.02675 4.5634 7.70541 4.16602 6.25 4.16602C4.79459 4.16602 3.47325 4.5634 2.5 5.21V16.0433C3.47325 15.3967 4.79459 14.9993 6.25 14.9993C7.70541 14.9993 9.02675 15.3967 10 16.0433M10 5.21C10.9732 4.5634 12.2946 4.16602 13.75 4.16602C15.2054 4.16602 16.5268 4.5634 17.5 5.21V16.0433C16.5268 15.3967 15.2054 14.9993 13.75 14.9993C12.2946 14.9993 10.9732 15.3967 10 16.0433"
        stroke={strokeColor}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
